import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44f735bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "demo-control-panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "force" }, "D3-Force enabled", -1))
const _hoisted_4 = { class: "fit_zoom" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("To center")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Fit")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Zoom In")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Zoom Out")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Create Graph ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Download Graph ")

import { computed } from "vue"
import {ForceLayout} from "v-network-graph/lib/force-layout"
import {VNetworkGraphInstance, EventHandlers } from "v-network-graph"

import { ref,reactive, toRefs } from 'vue'
import demo_label_config_panel from '@/components/NodeConfigPanel.vue'
import { defineComponent } from "vue"
import * as vNG from "v-network-graph"
const __default__ = defineComponent ({
  name: 'GraphView',
  props: ['prac','source','target'],
  components: {
    demo_label_config_panel
  },
  data(){
    return {
      e1:"",
      e2:"",
    nodes:{} as { [key: string]: { name: string;URL:string;size: number;label: boolean;color:string } },
    edges:{} as { [key: string]: { source: string; target: string} },
    //graph:ref<vNG.Instance>()
    }
  },
  methods: {
    gr() {    
    //  const { prac } = toRefs(props)
    //  const n = reactive( prac.value )
    //  const n= prac.length
    const n = this.prac
    this.nodes={}
    this.edges={}
    const x = this.source
    const y = this.target
    console.log(x)
    console.log(y)
    for (let i = 0; i < n.length; i++) {
    this.nodes[`${n[i][x]}`] = {
    name: `${n[i][x]}`,
    URL: `${n[i][x]}`,
    size: 12,
    label: true,
    color:`Red`
  },
  this.nodes[`${n[i][y]}`] = {
    name: `${n[i][y]}`,
    URL: `${n[i].URL}`,
    size: 12,
    label: true,
    color:`blue`
  };
}
    for (let i=0;i<n.length;i++){      
      this.edges[`edge${i}`]={
        source:`${n[i][x]}`,
        target:`${n[i][y]}`
      }
    }
    console.log(this.nodes)
    console.log(this.edges)
  // return { this.nodes, this.edges }
  }
  
  
}})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const configs = reactive(
  vNG.defineConfigs({
    view: {
      boxSelectionEnabled: true,
      autoPanOnResize: true,
      minZoomLevel: 0.1,
      maxZoomLevel: 16,
      layoutHandler: new ForceLayout({
        positionFixedByDrag: false,
        positionFixedByClickWithAltKey: true
      }),
    },
    node: {
      selectable: true,
      normal: {
        type: "circle",
        radius: node => node.size, // Use the value of each node object
        color: node => node.color,
      },
      hover: {
        type: "circle",
        radius: node => node.size + 2,
        color: "#dd2288",
        // for type is "rect" -->
        width: 32,
        height: 32,
        borderRadius: 4,
        // <-- for type is "rect"
        strokeWidth: 0,
        strokeColor: "#000000",
        strokeDasharray: "0",
      },
      selected: {
        type: "circle",
        radius: node => node.size + 2,
        // for type is "rect" -->
        width: 32,
        height: 32,
        borderRadius: 4,
        // <-- for type is "rect"
        strokeWidth: 0,
        strokeColor: "#000000",
        strokeDasharray: "0",
        color:"#4466cc",
      },
      label: {
        visible: node => !!node.label,
        fontFamily: undefined,
        fontSize: 11,
        lineHeight: 1.1,
        color: "#000000",
        margin: 4,
        direction: "south",
        background: {
          visible: false,
          color: "#ffffff",
          padding: {
            vertical: 1,
            horizontal: 4,
          },
          borderRadius: 2,
        },
      },
      focusring: {
        visible: true,
        width: 4,
        padding: 3,
        dasharray: "0",
        color: "darkgray",
      },
    },
    edge: {
      selectable: true,
      normal: {
        width: edge => edge.width, // Use the value of each edge object
        color: edge => edge.color,
        dasharray: edge =>(edge.dashed ? "4" : "0"),
      },
      marker: {
        source: {
          type: "none",
          width: 4,
          height: 4,
          margin: -1,
          units: "strokeWidth",
          color: null,
        },
        target: {
          type: "arrow",
          width: 10,
          height: 10,
          margin: -1,
          units: "strokeWidth",
          color: null,
        },
    },
    },
  })
)
const d3ForceEnabled = computed({
  get: () => configs.view.layoutHandler instanceof ForceLayout,
  set: (value: boolean) => {
    if (value) {
      configs.view.layoutHandler = new ForceLayout()
    } else {
      configs.view.layoutHandler = new vNG.SimpleLayout()
    }
  },
})
const graph = ref<vNG.Instance>()
function downloadasSVG(){
    if(!graph.value) return
    const text = graph.value.getAsSvg()
    const url = URL.createObjectURL(new Blob([text],{type:"octet/stream"}))
    const a = document.createElement("a")
    a.href = url
    a.download = "graph.svg"
    a.click()
    window.URL.revokeObjectURL(url)
    //console.log(text)
    
  }
  const isBoxSelectionMode = ref(false)
const eventHandlers: EventHandlers = {
  "view:mode": mode => {
    // Observe mode change events
    isBoxSelectionMode.value = mode === "box-selection"
  },
}
//const zoomLevel = ref(1)

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_download = _resolveComponent("download")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_v_network_graph = _resolveComponent("v-network-graph")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, { label: "hover" }, {
                  default: _withCtx(() => [
                    _createVNode(demo_label_config_panel, {
                      type: configs.node.hover.type,
                      "onUpdate:type": _cache[0] || (_cache[0] = ($event: any) => ((configs.node.hover.type) = $event)),
                      radius: configs.node.hover.radius,
                      "onUpdate:radius": _cache[1] || (_cache[1] = ($event: any) => ((configs.node.hover.radius) = $event)),
                      width: configs.node.hover.width,
                      "onUpdate:width": _cache[2] || (_cache[2] = ($event: any) => ((configs.node.hover.width) = $event)),
                      height: configs.node.hover.height,
                      "onUpdate:height": _cache[3] || (_cache[3] = ($event: any) => ((configs.node.hover.height) = $event)),
                      borderRadius: configs.node.hover.borderRadius,
                      "onUpdate:borderRadius": _cache[4] || (_cache[4] = ($event: any) => ((configs.node.hover.borderRadius) = $event)),
                      strokeWidth: configs.node.hover.strokeWidth,
                      "onUpdate:strokeWidth": _cache[5] || (_cache[5] = ($event: any) => ((configs.node.hover.strokeWidth) = $event)),
                      strokeColor: configs.node.hover.strokeColor,
                      "onUpdate:strokeColor": _cache[6] || (_cache[6] = ($event: any) => ((configs.node.hover.strokeColor) = $event)),
                      strokeDasharray: configs.node.hover.strokeDasharray,
                      "onUpdate:strokeDasharray": _cache[7] || (_cache[7] = ($event: any) => ((configs.node.hover.strokeDasharray) = $event)),
                      color: configs.node.hover.color,
                      "onUpdate:color": _cache[8] || (_cache[8] = ($event: any) => ((configs.node.hover.color) = $event))
                    }, null, 8, ["type", "radius", "width", "height", "borderRadius", "strokeWidth", "strokeColor", "strokeDasharray", "color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, { label: "selected" }, {
                  default: _withCtx(() => [
                    _createVNode(demo_label_config_panel, {
                      type: configs.node.selected.type,
                      "onUpdate:type": _cache[9] || (_cache[9] = ($event: any) => ((configs.node.selected.type) = $event)),
                      radius: configs.node.selected.radius,
                      "onUpdate:radius": _cache[10] || (_cache[10] = ($event: any) => ((configs.node.selected.radius) = $event)),
                      width: configs.node.selected.width,
                      "onUpdate:width": _cache[11] || (_cache[11] = ($event: any) => ((configs.node.selected.width) = $event)),
                      height: configs.node.selected.height,
                      "onUpdate:height": _cache[12] || (_cache[12] = ($event: any) => ((configs.node.selected.height) = $event)),
                      borderRadius: configs.node.selected.borderRadius,
                      "onUpdate:borderRadius": _cache[13] || (_cache[13] = ($event: any) => ((configs.node.selected.borderRadius) = $event)),
                      strokeWidth: configs.node.selected.strokeWidth,
                      "onUpdate:strokeWidth": _cache[14] || (_cache[14] = ($event: any) => ((configs.node.selected.strokeWidth) = $event)),
                      strokeColor: configs.node.selected.strokeColor,
                      "onUpdate:strokeColor": _cache[15] || (_cache[15] = ($event: any) => ((configs.node.selected.strokeColor) = $event)),
                      strokeDasharray: configs.node.selected.strokeDasharray,
                      "onUpdate:strokeDasharray": _cache[16] || (_cache[16] = ($event: any) => ((configs.node.selected.strokeDasharray) = $event)),
                      color: configs.node.selected.color,
                      "onUpdate:color": _cache[17] || (_cache[17] = ($event: any) => ((configs.node.selected.color) = $event))
                    }, null, 8, ["type", "radius", "width", "height", "borderRadius", "strokeWidth", "strokeColor", "strokeDasharray", "color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "force",
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(d3ForceEnabled) ? (d3ForceEnabled).value = $event : null))
        }, null, 512), [
          [_vModelCheckbox, _unref(d3ForceEnabled)]
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (graph.value?.panToCenter()))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[20] || (_cache[20] = ($event: any) => (graph.value?.fitToContents()))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (graph.value?.zoomIn()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (graph.value?.zoomOut()))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_button, {
        type: "warning",
        round: "",
        onClick: _ctx.gr
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: downloadasSVG
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_download)
            ]),
            _: 1
          }),
          _hoisted_10
        ]),
        _: 1
      }),
      _createVNode(_component_v_network_graph, {
        ref_key: "graph",
        ref: graph,
        nodes: _ctx.nodes,
        edges: _ctx.edges,
        configs: configs,
        "event-handlers": eventHandlers
      }, null, 8, ["nodes", "edges", "configs"])
    ])
  ]))
}
}

})